<template>
  <main>
    <div class="page">
      <header class="page-header">
        <h1>{{ categoryName }}</h1>
      </header>
      <div class="page-content post-list" v-if="posts && posts.length">
         <div class="post" v-for="post in posts" :key="post.postId">
          <h2 class="post-title">
            <template v-if="post.exLink.type === 'none'">{{ post.title }}</template>
            <router-link v-else-if="post.exLink.type === 'detail'" :to="'/news/' + post.postId">{{ post.title }}</router-link>
            <router-link v-else-if="post.exLink.type === 'inner'" :to="post.exLink.url">{{ post.title }}</router-link>
            <a v-else-if="post.exLink.type === 'outer'" :href="post.exLink.url" target="_blank" rel="noopener">{{ post.title }}</a>
            <a v-else-if="post.exLink.type === 'download'" :href="post.exLink.url" download>{{ post.title }}</a>
          </h2>
          <div class="post-body">
            <p class="post-date">{{ getFormatDate(post.date) }}</p>
          </div>
        </div>
      </div>
      <div class="page-content" v-else>
        <p>お知らせはありません</p>
      </div>
    </div>
  </main>
</template>

<script>
import getPostsByCategoryNameGql from '../apollo/queries/getPostsByCategoryName.gql'

export default {
  data () {
    return {
      posts: []
    }
  },
  methods: {

  },
  computed: {
    categoryName() {
      return this.posts[0] ? this.posts[0].categories.nodes[0].name : null
    }
  },
  apollo: {
    posts: {
      query: getPostsByCategoryNameGql,
      update: data => data.posts.nodes,
      variables () {
        return {
          categorySlug: this.$route.params.categorySlug
        }
      },
    },
  }
}
</script>

<style lang="stylus" scoped>


</style>
